import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'room_positions': '[RoomPositionInputType]',
};

export default gql(`
	mutation room_positions( ${ HelperGraphql.createFields( fields ) } ) {
	    room_positions( ${ HelperGraphql.createVariables( fields ) } ) {
	       guid
	       position
	    }
	}
`);

